import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss']
})
export class WhatsappComponent implements OnInit, OnDestroy {

  public status: string = 'loading';
  public qrDataUrl: string = '';
  public company_uuid: string = '';
  private pollInterval: any = null;

  constructor(private router: Router, private http: HttpService) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngOnInit(): void {
    this.checkStatus();
  }

  ngOnDestroy(): void {
    if (this.pollInterval) clearInterval(this.pollInterval);
  }

  async checkStatus() {
    const res: any = await this.http.post('/admin/chat/whatsapp/status');
    this.status = res?.connection_status || 'not_configured';

    if (this.status === 'connected') {
      this.qrDataUrl = '';
      if (this.pollInterval) clearInterval(this.pollInterval);
      return;
    }

    if (this.status === 'qr_needed') {
      await this.fetchQR();
    }

    if (!this.pollInterval) {
      this.pollInterval = setInterval(() => this.checkStatus(), 5000);
    }
  }

  async fetchQR() {
    const res: any = await this.http.post('/admin/chat/whatsapp/qr');
    if (res?.status && res.qr) {
      this.qrDataUrl = await QRCode.toDataURL(res.qr, { width: 280, margin: 2 });
    } else {
      this.qrDataUrl = '';
    }
  }

  async initWhatsApp() {
    this.status = 'initializing';
    const res: any = await this.http.post('/admin/chat/whatsapp/init', { config: {} });
    this.http.notify(res?.message || 'Initializing...');
    if (!this.pollInterval) {
      this.pollInterval = setInterval(() => this.checkStatus(), 5000);
    }
  }

  async disconnect() {
    if (!confirm('Disconnect WhatsApp?')) return;
    await this.http.post('/admin/chat/whatsapp/disconnect');
    this.status = 'disconnected';
    this.qrDataUrl = '';
    this.http.notify('WhatsApp disconnected');
  }

  goToChat() {
    this.router.navigate(['/lo', this.company_uuid, 'chat'], { queryParams: { channel: 'whatsapp' } });
  }
}
